/* eslint-disable prettier/prettier */
const currenciesWithLargeDenominations = [
  'KRW',
  'JPY',
  'PLN',
  'SEK',
  'DKK',
  'NOK',
  'HUF',
  'INR',
  'TRY',
  'CZK',
  'ZAR',
  'CHF',
  'ILS',
];

const storeSpecificDenominations = {
  '2119': 120000,
};

export const getMaxAmountByCurrency = (currency, storeNumber = null) => {
  if (storeNumber && storeSpecificDenominations[storeNumber]) {
    return storeSpecificDenominations[storeNumber];
  }

  return currenciesWithLargeDenominations.includes(currency) ? 1000000000 : 100000;
}
